import { KnowEdmTableValue } from '../interfaces.js';
import { KnowEdmTableData } from './table-enums.js';

const fieldCRSSettingsMap = new Map<KnowEdmTableData, KnowEdmTableValue<KnowEdmTableData>>();

fieldCRSSettingsMap.set(KnowEdmTableData.GeodeticDatum, {
  key: KnowEdmTableData.GeodeticDatum,
  label: 'Geodetic Datum',
  unit: '',
  quantity: '',
  tooltip: 'entities_geodeticDatumTooltip',
});

fieldCRSSettingsMap.set(KnowEdmTableData.MapSystem, {
  key: KnowEdmTableData.MapSystem,
  label: 'Map System',
  unit: '',
  quantity: '',
  tooltip: 'entities_mapSystemTooltip',
});

fieldCRSSettingsMap.set(KnowEdmTableData.MapZone, {
  key: KnowEdmTableData.MapZone,
  label: 'Map Zone',
  unit: '',
  quantity: '',
  tooltip: 'entities_mapZoneTooltip',
});

fieldCRSSettingsMap.set(KnowEdmTableData.EPSGCode, {
  key: KnowEdmTableData.EPSGCode,
  label: 'EPSG Code',
  unit: '',
  quantity: '',
  tooltip: 'entities_epsgCodeTooltip',
});

export { 
  fieldCRSSettingsMap,
};